import React from 'react';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../../components/InputFilterItem';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface FilterOptions {
  addressHash?: string;
  normalizedStreet?: string;
  normalizedUnit?: string;
  zipcode?: string;
}

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  addressHash: undefined,
  normalizedStreet: undefined,
  normalizedUnit: undefined,
  zipcode: undefined,
};

interface FilterAreaProps {
  filters: FilterOptions;
  setFilters: (filters: FilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  const handleChange = (key: keyof FilterOptions, value: string | undefined) => {
    const processed = typeof value === 'string' && value.trim() === '' ? undefined : value;
    setFilters({ ...filters, [key]: processed });
  };

  const columnLabels = [
    t('mapTool.addressInvalid.filters.addressHash'),
    t('mapTool.addressInvalid.filters.normalizedStreet'),
    t('mapTool.addressInvalid.filters.normalizedUnit'),
    t('mapTool.addressInvalid.filters.zipcode'),
  ];
  const labelClassName = getSmartLabelClassName(columnLabels);

  return (
    <div className="mb-2 pl-0 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressInvalid.filters.addressHash')}
            value={filters.addressHash ?? ''}
            onChange={(e) => handleChange('addressHash', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressInvalid.placeholders.addressHashExact') as string}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressInvalid.filters.normalizedStreet')}
            value={filters.normalizedStreet ?? ''}
            onChange={(e) => handleChange('normalizedStreet', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressInvalid.placeholders.normalizedStreetFuzzy') as string}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressInvalid.filters.normalizedUnit')}
            value={filters.normalizedUnit ?? ''}
            onChange={(e) => handleChange('normalizedUnit', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressInvalid.placeholders.normalizedUnitExact') as string}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressInvalid.filters.zipcode')}
            value={filters.zipcode ?? ''}
            onChange={(e) => handleChange('zipcode', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressInvalid.placeholders.zipcodeExact') as string}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterArea;